import { DefaultState } from 'store/types';

export const EDIT_LODGING_OPTION_DATA_REQUEST = 'EDIT_LODGING_OPTION_DATA_REQUEST';
export const EDIT_LODGING_OPTION_DATA_SUCCESS = 'EDIT_LODGING_OPTION_DATA_SUCCESS';
export const EDIT_LODGING_OPTION_DATA_FAILURE = 'EDIT_LODGING_OPTION_DATA_FAILURE';

export interface EditLodgingOptionParams {
  id?: string;
  name: string;
  lodgingType: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  location: {
    longitude: number;
    latitude: number;
  };
  checkInDetails?: string;
  checkOutDetails?: string;
  notes?: string;
  website?: string;
  lodgingManager: {
    name: string;
    phoneNumber: string;
    email?: string;
  };
};

export interface EditLodgingOptionData {
  id: string;
}

export type EditLodgingOptionState = DefaultState & {
  contents?: EditLodgingOptionData;
};

interface EditLodgingOptionDataRequest {
  type: typeof EDIT_LODGING_OPTION_DATA_REQUEST;
};

interface EditLodgingOptionDataSuccess {
  type: typeof EDIT_LODGING_OPTION_DATA_SUCCESS,
  contents: EditLodgingOptionData;
}

interface EditLodgingOptionDataFailure {
  type: typeof EDIT_LODGING_OPTION_DATA_FAILURE;
}

export type EditLodgingOptionActionTypes = EditLodgingOptionDataRequest | EditLodgingOptionDataSuccess | EditLodgingOptionDataFailure;